import styled from 'styled-components';

export const LabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${({ theme }) => theme.space[3]}px;
`;
